var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 450,
    viewBox: "0 0 428 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "right_down_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 428,
    height: 452
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h428v452H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#right_down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M969.5 614.5c0 223.848-187.988 407-422 407s-422-183.152-422-407 187.988-407 422-407 422 183.152 422 407z",
    stroke: "#81E1C1",
    strokeOpacity: 0.67,
    strokeWidth: 59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.5 1101c276.405 0 503.5-217.067 503.5-488.5S823.905 124 547.5 124 44 341.067 44 612.5 271.095 1101 547.5 1101z",
    stroke: "#F4F8FE",
    strokeOpacity: 0.13,
    strokeWidth: 104
  }))));
}

export default __webpack_public_path__ + "./fonts/right_down.89cfefec5146ad6ce4de295964679694.svg";
export { SvgRightDown as ReactComponent };